module.exports = __webpack_public_path__ + "img/analysis_menu.4dd0ffc3.svg";